<template>
    <div>
        <div class="filter-box" v-if="isTableMounted">
            <div class="d-flex mb-4 px-3 px-sm-4">
                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                    <b-input-group class="username-input-field">
                        <b-form-input type="text" :placeholder="$t('maintenanceShared.search')" v-model="filterFields.search" class="unit f-12"
                            @keyup.enter="getMaintenanceData()"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary" @click="getMaintenanceData()">
                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="d-none d-md-block mb-0 report-fields">
                    <date-picker v-model="filterFields.date" :formatter="momentFormat" @change="getMaintenanceData()"
                        :range-separator="' - '" @clear="filterFields.date = ''" :placeholder="$t('maintenanceShared.selectDate')" range
                        :shortcuts="shortcuts"></date-picker>
                </b-form-group>
                <div class="ml-auto d-none d-sm-flex flex-wrap align-items-center">
                    <div class="position-relative">
                        <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                            {{ activeFiltersCount }}
                        </div>
                        <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                            <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-sliders-horizontal w-4 h-4"
                                    data-id="element-964">
                                    <line x1="21" x2="14" y1="4" y2="4"></line>
                                    <line x1="10" x2="3" y1="4" y2="4"></line>
                                    <line x1="21" x2="12" y1="12" y2="12"></line>
                                    <line x1="8" x2="3" y1="12" y2="12"></line>
                                    <line x1="21" x2="16" y1="20" y2="20"></line>
                                    <line x1="12" x2="3" y1="20" y2="20"></line>
                                    <line x1="14" x2="14" y1="2" y2="6"></line>
                                    <line x1="8" x2="8" y1="10" y2="14"></line>
                                    <line x1="16" x2="16" y1="18" y2="22"></line>
                                </svg>
                                <p class="mb-0 ml-2">{{ $t('maintenanceShared.filters') }}</p>
                            </div>
                        </button>
                    </div>
                    <div class="table-columns-section ml-2 mt-0" @click="showColumns = true">
                        <button class="btn btn-table-columns-section">
                            <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-columns2 w-4 h-4" data-id="element-961">
                                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                    <path d="M12 3v18"></path>
                                </svg>
                                <p class="mb-0 ml-2">{{ $t('maintenanceShared.columns') }}</p>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 225px); overflow: hidden;">
            <b-skeleton-table :rows="17" :columns="7"
                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
        </div>
        <b-table v-else ref="tableRef" class="mt-2" responsive :fields="visibleFields" :items="items" hover
            :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true"
            :busy.sync="isBusy" :sticky-header="'calc(100vh - 330px)'" :show-empty="emptyTable" selectable
            select-mode="multi" no-select-on-click @row-selected="onRowSelected">
            <template #head(selected)="">
                <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)" v-model="allRowsSelected">
                </b-form-checkbox>
            </template>
            <template #cell(selected)="data">
                <b-form-checkbox class="pl-0 w-fit-content" @change="checked(data.index, data.rowSelected)"
                    v-model="data.rowSelected">
                </b-form-checkbox>
            </template>
             <template #cell(source)="data">
                        <svg v-if="data.value === 'bot'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.07751 18.9975V15.5368H6.53822" stroke="#2D69F6" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M18.8442 8.34855C19.7053 12.9277 16.9031 17.4673 12.328 18.6933C8.82635 19.6315 5.25353 18.3694 3.07751 15.7545"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M1.15502 11.6536C0.293936 7.07442 3.09617 2.53472 7.67127 1.30883C11.1727 0.370634 14.7452 1.63251 16.9213 4.24705"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M16.9219 1V4.46071H13.4612" stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M5.93818 10.4693C5.4485 10.3842 5.4485 9.6812 5.93818 9.59601C7.71219 9.28739 9.12316 7.93616 9.50822 6.17717L9.53773 6.04233C9.64368 5.55838 10.3328 5.55536 10.4429 6.03837L10.4788 6.1955C10.8781 7.94621 12.2894 9.28601 14.0585 9.59378C14.5506 9.67942 14.5506 10.3859 14.0585 10.4716C12.2894 10.7793 10.8781 12.1192 10.4788 13.8698L10.4429 14.027C10.3328 14.51 9.64368 14.507 9.53773 14.023L9.50822 13.8882C9.12316 12.1292 7.71219 10.778 5.93818 10.4693Z"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div v-else>-</div>

                      </template>
            <template #cell(types_read)="data">
                      <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0] }}</div>
                        <v-app>
                          <v-tooltip bottom v-if="data.value.length > 1">
                            <template #activator="{ on, attrs }">
                              <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                            </template> <span v-html="data.value.slice(1).join('<br>')"></span>
                          </v-tooltip>
                        </v-app>
                      </div>
                      <p class="mb-0" v-else>-</p>
                    </template>
            <template #cell(record_no)="data">
                <p class="mb-0 cursor-pointer text_primary mb-0" @click="recordID = data.item.pk" v-if="allowViewRecord">{{
                    data.value }}</p>
                <p class="mb-0" v-else>{{ data.value }}</p>
            </template>
            <template #cell(description)="data">
                <v-app v-if="data.value && data.value !== 'null'">
                    <v-tooltip top>
                        <template #activator="{ on, attrs }">
                            <span class="w-fit-content item-description text-left mw-400px" v-on="on" v-bind="attrs">{{
                                data.value }}</span>
                        </template>{{ formatTooltipText(data.value) }}
                    </v-tooltip>
                </v-app>
                <p v-else>-</p>
            </template>

            <template #cell(amount)="data">
                {{
                    data.value !== "-" ? `$${getAmount(data.value)}` : "-"
                }}
            </template>
            <template #cell(odometer)="data">
                {{ data.value ? data.value.toLocaleString() : "" }}
            </template>
            <template #cell(status)="data">
                <b-button class="btn f-14 pe-none d-flex justify-content-center align-items-center"
                    :variant="data.item.status === 'New' ? 'warning-status' : data.item.status === 'Urgent' ? 'danger-status' : data.item.status === 'Open' ? 'success-status' : 'secondary-status'">
                    <p class="mb-0">{{ data.value }}</p>
                </b-button>
            </template>
            <template v-slot:custom-foot v-if="visibleFields.filter((item) => item.key === 'amount').length">
                <tr class="sticky-footer">
                    <td v-for="(field, index) in visibleFields" :key="index">
                        <span v-if="field.key === 'amount'" class="font-weight-bold">{{ totalAmount ?
                            `$${getAmount(totalAmount)}` : "-" }}</span>
                    </td>
                </tr>
            </template>
        </b-table>
        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
            <div class="d-flex align-items-center flex-wrap">
                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                    <b-form-select v-model="perPage" :options="pageOptions" />
                </div>
                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                <div class="pagination">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="my-table"></b-pagination>
                </div>
            </div>
        </div>
        <DeleteModal v-if="showModal" @confirm="deleteItem($event)" />
        <EditRecord :recordID="recordID" @resetMaintenance="recordID = null" @recordUpdated="getMaintenanceData()" />
        <AddRecord @close="$emit('close')" :allowAddRecord="allowAddRecord" @recordAdded="getMaintenanceNewData($event)" />
        <TableColumns :showColumns="showColumns" :fields="fields" @getUpdatedFieldsList="getUpdatedFieldsList($event)"
            @updateFields="updateFields($event)" @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
        <b-modal id="modal-filter" centered no-close-on-backdrop no-close-on-esc
      :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block p-3 m-0'"
      :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('maintenanceShared.filters') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-form-group :label="$t('maintenanceShared.type')" class="text-left select_arrow label mb-3">
                    <b-form-select v-model="filterFields.type" class="input f-12" :options="typeFilterOptions" @change="getMaintenanceData()"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.unitNo')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="allEquipments" :reduce="(option) => option.id"
                        v-model="filterFields.unit_no" @input="getMaintenanceData()" @search="searchAssets"/>
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.tags')" class="text-left w-equipment-box mb-3">
                    <v-select multiple class="f-12 bg-grey" :options="allTags" :reduce="(option) => option.id"
                        v-model="filterFields.tags" @input="getMaintenanceData()" />
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.vendor')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="allVendors" :reduce="(option) => option.id"
                        v-model="filterFields.vendor_name" @input="getMaintenanceData()" />
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.types')" class="text-left w-equipment-box mb-3">
                    <v-select multiple class="f-12 bg-grey" :options="allTypes" :reduce="(option) => option.id"
                        v-model="filterFields.types" @input="getMaintenanceData()" />
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.status')" class="text-left select_arrow label mb-3">
                    <b-form-select v-model="filterFields.status" type="text" class="input f-12" :options="statusFilterOptions" @change="getMaintenanceData()"></b-form-select>
                </b-form-group>

            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('maintenanceShared.reset') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                        @click="$bvModal.hide('modal-filter')">{{ $t('maintenanceShared.close') }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AddRecord from "@/components/Maintenance/AddRecord";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css"
import TableColumns from "@/components/Shared/TableColumns.vue";
import * as moment from "moment-timezone";
// import DateRangePicker from 'vue2-daterange-picker'
import DeleteModal from "@/components/DeleteModal.vue";
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import EditRecord from "@/components/Maintenance/EditRecord";
import JSZip from "jszip"

export default {
    name: "Records",
    components: { vSelect, DeleteModal, DatePicker, AddRecord, EditRecord, TableColumns },
    props: ["allowAddRecord"],
    data() {
        return {
            showColumns: false,
            recordID: null,
            selectedRows: [],
            filterFields: {
                search: '',
                date: '',
                type: '',
                tags: [],
                types: [],
                vendor_name: '',
                status: '',
                unit_no: ''
            },
            momentFormat: {
                //[optional] Date to String
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                //[optional]  String to Date
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            rows: 0,
            allTags: [],
            allTypes: [],
            allVendors: [],
            allEquipments: [],
            allRowsSelected: false,
            positionText: "",
            fields: [],
            items: [],
            totalAmount: 0,
            showModal: false,
            itemId: null,
            sortBy: undefined,
            sortDesc: undefined,
            maintenanceId: null,
            isBusy: false,
            isTableMounted: false,
            perPage: 10,
            emptyTable: false,
            currentPage: 1,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            shortcuts: [
                {
                    text: 'This Week',
                    onClick: () => {
                        const today = new Date();
                        const dayOfWeek = today.getDay() || 7;
                        const startOfWeek = new Date(today);
                        startOfWeek.setDate(today.getDate() - dayOfWeek + 1);
                        this.filterFields.date = [startOfWeek, today];
                        this.getMaintenanceData()
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        const today = new Date();
                        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                        this.filterFields.date = [startOfMonth, today];
                        this.getMaintenanceData()
                    },
                },
                {
                    text: 'This Year',
                    onClick: () => {
                        const today = new Date();
                        const startOfYear = new Date(today.getFullYear(), 0, 1);
                        this.filterFields.date = [startOfYear, today];
                        this.getMaintenanceData()
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        const today = new Date();
                        const dayOfWeek = today.getDay() || 7;
                        const startOfLastWeek = new Date(today);
                        startOfLastWeek.setDate(today.getDate() - dayOfWeek - 6);
                        const endOfLastWeek = new Date(today);
                        endOfLastWeek.setDate(today.getDate() - dayOfWeek);
                        this.filterFields.date = [startOfLastWeek, endOfLastWeek];
                        this.getMaintenanceData()
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        const today = new Date();
                        const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                        const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                        this.filterFields.date = [startOfLastMonth, endOfLastMonth];
                        this.getMaintenanceData()
                    },
                },
                {
                    text: 'Last Year',
                    onClick: () => {
                        const today = new Date();
                        const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
                        const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
                        this.filterFields.date = [startOfLastYear, endOfLastYear];
                        this.getMaintenanceData()
                    },
                },
            ]
        }
    },
    methods: {
        ...mapActions(['setLoader', 'retrieveDocument', 'getFilteredEquipments', 'getMaintenance', 'getAllTags', "setMaintenance", "deleteMaintenance", 'setNotification', 'getMaintenanceRecordsExportData', 'updateUserPreferences', 'deleteUserPreferences', 'getAllVendors', 'getAllTypes']),
        getExtensionFromMimeType(mimeType) {
            const mimeMap = {
                'application/pdf': 'pdf',
                'image/jpeg': 'jpg',
                'image/png': 'png',
            };

            return mimeMap[mimeType] || '';
        },
        async searchAssets(searchText) {
            if(searchText) {
            let options = []
            const equipmentRecords = await this.getFilteredEquipments({unit_no:searchText});
            equipmentRecords.map((item) => {
                options.push({
                    id: item.id,
                    label: item.unit_no,
                });
            });
            this.allEquipments = [...new Map(options.map(item => [item['id'], item])).values()]
            }
        },
        async downloadBulkFiles() {
            this.setLoader(true);
            const zip = new JSZip();

            try {
                const folderName = this.company[0].name || "Documents";
                const folder = zip.folder(folderName);

                const allDocumentPromises = this.selectedRows.flatMap((record) =>
                    record.documents.map(async (doc, index) => {
                        try {
                            const response = await fetch(doc.document);
                            if (!response.ok) throw new Error(`Failed to fetch: ${doc.document}`);

                            const blob = await response.blob();
                            const extension = this.getExtensionFromMimeType(blob.type) || 'file';
                            const fileName = `${record.record_no}-${record.unit_no}-${index + 1}.${extension}`;

                            folder.file(fileName, blob);
                        } catch (err) {
                            console.error(`Error downloading document ${doc.document}:`, err);
                        }
                    })
                );

                await Promise.all(allDocumentPromises);

                const content = await zip.generateAsync({ type: "blob" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(content);
                link.download = `${folderName}.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$refs.tableRef.clearSelected();
                this.allRowsSelected = false;
            } catch (error) {
                console.error("Error during bulk download:", error);
            } finally {
                this.setLoader(false);
            }
        },
        checked(index, checked) {
            let tableRef = this.$refs.tableRef
            if (checked === true) tableRef.selectRow(index)
            else tableRef.unselectRow(index)
        },
        selectRows(checked) {
            if (checked) {
                this.$refs.tableRef.selectAllRows()
            }
            else {
                this.$refs.tableRef.clearSelected()
                this.allRowsSelected = false
            }
        },
        onRowSelected(items) {
            this.selectedRows = items
            this.$emit('getSelectedRowsLength', this.selectedRows.length)
        },
        async getUpdatedFieldsList(updatedFields) {
            this.fields = updatedFields
            try {
                const updatedOrderList = updatedFields.map((item, index) => {
                    return { ...item, display_order: index + 1 }
                })
                await this.updateUserPreferences(
                    {
                        "columns": updatedOrderList
                    })
            }
            catch (e) {
                console.log(e)
            }
        },
        async getMaintenanceNewData(id = null) {
            this.allowAddRecord = false
            await this.getMaintenanceData()
            if (id) this.recordID = id
            this.$emit('close');
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                type: '',
                date: '',
                tags: [],
                types: [],
                vendor_name: '',
                status: '',
                unit_no: ''
            }
            await this.getMaintenanceData();
        },
        async deleteRecord(id) {
            try {
                this.setLoader(true)
                await this.deleteMaintenance(`${id}/?company_id=${this.userCompany}`);
                await this.setNotification({
                    msg: this.$t('editMaintRecord.recordDeleted'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        showDeletePopup(id) {
            this.showModal = true;
            this.itemId = id;
        },
        deleteItem(item) {
            if (item) {
                this.deleteRecord(this.itemId);
            }
            this.showModal = false;
        },
        async resetTableFields() {
            try {
                this.setLoader(true)
                await this.deleteUserPreferences(`Maintenance/`)
                this.showColumns = false
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async updateFields(updatedFields) {
            this.fields = updatedFields
            this.filterFields = {
                search: '',
                type: '',
                date: '',
                tags: [],
                status: '',
                unit_no: ''
            }
            try {
                await this.updateUserPreferences({
                    "columns": updatedFields
                })
                await this.getMaintenanceData();
            }
            catch (e) {
                console.log(e)
            }
        },
        editMaintenance(item) {
            this.setMaintenance(item)
            this.$bvModal.show('modal-maintenance')
        },
        downloadFile(uri) {
            axios({
                method: 'get',
                url: uri,
                responseType: 'blob',
            }).then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const parts = uri.split('/');
                const lastPart = parts[parts.length - 1];
                const fileName = lastPart.split('?')[0];
                a.download = fileName
                document.body.appendChild(a);
                a.click();
                a.remove()
                window.URL.revokeObjectURL(url);
            });
        },
        getAmount(val) {
            return parseFloat(val).toLocaleString("en", {
                useGrouping: false,
                minimumFractionDigits: 2,
            });
        },
        async downloadExcel() {
            try {
                this.setLoader(true)
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if ((key === "tags" || key === "types") && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                    else if (key === 'date' && this.filterFields['date'][0]) {
                        url += `start_date=${moment(this.filterFields['date'][0]).format("YYYY-MM-DD")}&end_date=${moment(this.filterFields['date'][1]).format("YYYY-MM-DD")}&`
                    }
                    else if (this.filterFields[key] && key !== 'tags' && key !== 'date' && key !== 'types') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=unit_no&sort_order=asc&`
                }
                const data = await this.getMaintenanceRecordsExportData(url)
                const blob = new Blob([data], { type: 'text/csv' });
                const csvUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = csvUrl;
                a.download = 'records.csv';
                a.target = "_blank"
                document.body.appendChild(a);
                a.click();
                a.remove()
                window.URL.revokeObjectURL(csvUrl);
                await this.setNotification({
                    msg: this.$t('maintenanceRecords.fileExported'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)

            }
        },
        async getMaintenanceData() {
            try {
                this.isBusy = true
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if ((key === "tags" || key === "types") && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                    else if (key === 'date' && this.filterFields['date'][0]) {
                        url += `start_date=${moment(this.filterFields['date'][0]).format("YYYY-MM-DD")}&end_date=${moment(this.filterFields['date'][1]).format("YYYY-MM-DD")}&`
                    }
                    else if (this.filterFields[key] && key !== 'tags' && key !== 'date' && key !== 'types') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=record_no&sort_order=desc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getMaintenance(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('maintenanceShared.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('maintenanceShared.emptyPosition')
                }
                this.items = []
                this.totalAmount = data.total_amount
                data.records.forEach((m, id) => {
                    this.items.push({
                        id: id,
                        pk: m.id,
                        record_no: m.record_no,
                        unit_no: m.unit_no.unit_no,
                        type: m.unit_no.type,
                        date: moment(m.date).format("ll"),
                        description: m.description,
                        odometer: m.odometer,
                        amount: m.amount !== "0.0000" ? parseFloat(m.amount).toFixed(2) : "-",
                        link: m.document,
                        unit_id: m.unit_no?.id,
                        status: m.status,
                        vendor_read: m.vendor_read ? m.vendor_read.name : '-',
                        types_read: m.types_read.map((type) => type.name),
                        documents: m.documents,
                        source: m.source
                    });
                });
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },
    },
    computed: {
        ...mapGetters(['maintenance', 'tags', 'company', 'userCompany', 'rolePermissions', 'userPreferences', 'user', 'vendors', 'types']),
        typeFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'Vehicle', text: this.$t('maintenanceShared.vehicle') },
                { value: 'Trailer', text: this.$t('maintenanceShared.trailer') },
            ];
        },
        statusFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'New', text: this.$t('maintenanceShared.statusNew') },
                { value: 'Open', text: this.$t('maintenanceShared.statusOpen') },
                { value: 'Closed', text: this.$t('maintenanceShared.statusClosed') },
                { value: 'Urgent', text: this.$t('maintenanceShared.statusUrgent') },
            ];
        },
        allowViewRecord() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][0].allow
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (key === 'tags') {
                    return count + (this.filterFields.tags.length > 0 ? 1 : 0);
                }
                if (key === 'types') {
                    return count + (this.filterFields.types.length > 0 ? 1 : 0);
                }
                else if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
        visibleFields() {
            return this.fields.filter(field => field.visible)
        }
    },
    watch: {
        userPreferences: {
            async handler() {
                if (this.userPreferences) {
                    this.fields = this.userPreferences['Maintenance'].sort((a, b) => a.display_order - b.display_order).map((col) => {
                        return { ...col, thClass: 'font-table-weight-bold', ...col.key === 'selected' ? { thStyle: { minWidth: "20px", width: "20px" } } : {} }
                    })
                }
            },
            immediate: true
        },
        perPage: {
            async handler() {
                await this.getMaintenanceData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getMaintenanceData();
            },
        },
        sortBy: {
            async handler() {
                await this.getMaintenanceData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getMaintenanceData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
        company: {
            async handler() {
                await this.getAllTags(this.userCompany);
                await this.getAllVendors();
                await this.getAllTypes(this.userCompany);
                this.tags.map((item) => {
                    this.allTags.push({
                        id: item.add_tag,
                        label: item.add_tag,
                    });
                });
                this.vendors.map((item) => {
                    this.allVendors.push({
                        id: item.name,
                        label: item.name,
                    });
                });
                this.types.map((item) => {
                    this.allTypes.push({
                        id: item.name,
                        label: item.name,
                    });
                });
            },
            deep: true,
            immediate: true
        }
    },


}
</script>
<style>
.mx-datepicker-range {
    width: 250px !important;
}

.mx-datepicker-range .mx-input-wrapper .mx-input {
    background-color: #fafafa !important;
    border: 1px solid #e3e3e3 !important;
    height: 40px;
    box-shadow: none !important;
}

.mw-400px {
    max-width: 400px !important;
}
</style>